import { emptySplitApi as api } from "./emptyApi"

export interface CustomConnectorConfigField {
  format: "select"
  property_label: string
  configuration_path: string
  options_source?: string
  help_text?: string
}

export interface CustomConnectorPropertiesResponse {
  additional_config?: CustomConnectorConfigField[]
  metadata?: Record<string, unknown> | null
}

export interface CustomConnectorConfigOption {
  value: string
  label: string
  imageUrl?: string
  hint?: string
}

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    getCustomConnectorProperties: build.query<
      CustomConnectorPropertiesResponse,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `/company-connector/${id}/custom-properties`,
      }),
      providesTags: (_result, _error, arg) => [
        { type: "CompanyConnectors", id: arg.id },
      ],
    }),
    getCustomConnectorConfigOptions: build.query<
      CustomConnectorConfigOption[],
      { id: string; source: string }
    >({
      query: ({ id, source }) => ({
        url: `/company-connector/${id}/custom-config-options/${source}`,
      }),
    }),
    completeCustomConnectorSetup: build.mutation<
      unknown,
      { id: string; additionalConfig: Record<string, unknown> }
    >({
      query: ({ id, additionalConfig }) => ({
        url: `/company-connector/${id}/complete-custom-setup`,
        method: "POST",
        body: { additionalConfig },
      }),
      invalidatesTags: ["CompanyConnectors"],
    }),
  }),
})

export const {
  useGetCustomConnectorPropertiesQuery,
  useGetCustomConnectorConfigOptionsQuery,
  useCompleteCustomConnectorSetupMutation,
} = injectedRtkApi
